import axios from "axios";
import sysconfig from "@/constants/sysconfig";

export interface ReqOption {
  // TODO サーバー側で、ajax呼び出しかどうか判別しているので
  // ヘッダーを追加しないとセッションエラーとなる
  // axiosの判別方法があれば、サーバー側を修正したい
  method: any;
  url: string;
  params: any;
  headers?: any;
  data?: any;
  paramsSerializer?: (params: Record<string, any>) => string;
  encode?: boolean;
}

export class Api {
  // Request Server
  async sendRequest(
    option: ReqOption,
    method: "fetch" | "save" = "fetch"
  ): Promise<any> {
    //-----------------------------------------------------------------------
    // Headers setting
    option.headers = { "x-requested-with": "XMLHttpRequest" };
    if (sysconfig.analysis.endpointUrl) {
      if (option.url.indexOf(sysconfig.analysis.endpointUrl) > -1) {
        // 部分一致のときの処理
        delete option.headers; // ヘッダを削除
      }
    }

    if (method === "save") {
      option.headers["X-CSRF-Token"] = (window as any).SAILS_LOCALS?._csrf; // csrf
      if (sysconfig.logs.endpointUrl) {
        if (option.url.indexOf(sysconfig.logs.endpointUrl) > -1) {
          // 部分一致のときの処理
          delete option.headers;
          option.headers = { "Access-Control-Allow-Origin": "*" };
        }
      }
    }
    //-----------------------------------------------------------------------
    // Query Parameter setting
    option.params = option.params || {};
    const [baseUrl, queryParams] = option.url.split("?");
    if (queryParams) {
      const tempParams: Record<string, any> = {};
      const keysToReset = new Set<string>();

      for (const param of queryParams.split("&")) {
        const [key, value = ""] = param.split("=");
        const decodedKey = decodeURIComponent(key);
        const decodedValue = decodeURIComponent(value);

        // クエリに含まれるキーを記録
        keysToReset.add(decodedKey);

        // 一時的にクエリパラメータを構築
        if (tempParams[decodedKey] === undefined) {
          tempParams[decodedKey] = decodedValue;
        } else {
          if (Array.isArray(tempParams[decodedKey])) {
            tempParams[decodedKey].push(decodedValue);
          } else {
            tempParams[decodedKey] = [tempParams[decodedKey], decodedValue];
          }
        }
      }

      // クエリパラメータを再構築
      for (const key of keysToReset) {
        // クエリパラメータに該当するキーだけ削除
        delete option.params[key];
      }
      Object.assign(option.params, tempParams);

      // URLをベース部分だけにする
      option.url = baseUrl;
      option.encode = false;
      option.paramsSerializer = this.queryParamsSerializer;
    }
    option.params.syncDate = Date.now(); // 送信日
    //-----------------------------------------------------------------------
    // Request
    return await axios(option)
      .then((response) => {
        // console.log(response)
        return [response, null];
      })
      .catch((error) => {
        console.log("通信失敗");
        // console.log(error.status);
        return [null, { error: error }];
      });
  }

  // Serializer
  queryParamsSerializer(
    params: Record<string, string | number | boolean>
  ): string {
    return Object.entries(params)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}` // URIエンコード
      )
      .join("&");
  }
  // axios使用でリクエスト(GET)
  async fetch(option: ReqOption): Promise<any> {
    return await this.sendRequest(option);
  }

  // axios使用でリクエスト(POST、PUT、DELETE)
  async save(option: ReqOption): Promise<any> {
    return await this.sendRequest(option, "save");
  }
}
